<template>
  <div class="questionnaire-question-grid -double-" :class="advancedClass">
    <Select
      :value="showOtherOptionInput ? defaultValue : value"
      :options="options"
      opacity
      label="Ниша"
      placeholder="Укажи свою нишу"
      required
      @input="setValue"
    />
    <transition name="fade">
      <Input
        v-if="showOtherOptionInput"
        :value="value"
        required
        :error="false"
        error-message=""
        label="Название ниши"
        placeholder="Напишите название вашей ниши"
        type="text"
        @input="setValue"
      />
    </transition>
  </div>
</template>

<script>
import Select from '@/components/UiKit/v2/Select';
import Input from '@/components/UiKit/v2/Input';

export default {
  components: {
    Select,
    Input
  },
  props: {
    option: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: String,
      default: ''
    },
    advancedClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      otherOptionSelected: false,
      defaultValue: 'Другое',
      otherOption: '',
      options: [
        'Ремонт, строительство и недвижимость',
        'Фастфуд и общепит',
        'Консалтинг',
        'Производство',
        'Продажа услуг',
        'Бьюти',
        'Спорт и здоровье',
        'Образование',
        'Маркетинг',
        'Маркетплейсы',
        'Ритейл',
        'Другое'
      ]
    };
  },
  computed: {
    showOtherOptionInput() {
      return this.value === this.defaultValue || !this.options.some(item => item === this.value);
    }
  },
  watch: {
    value() {
      if (this.value === this.defaultValue) {
        this.setValue('');
      }
    }
  },
  methods: {
    setValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>
